import React, { ReactElement } from 'react';
import { QHeading, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import {
  ReassignChangeRequestsMap,
  ReassignDocumentsMap,
  ReassignControlsMap,
  ReassignDocumentTemplatesMap,
} from '../../types';
import { filterUniqueOwners } from '../../utils';
import { ReassignOwnerSummaryItemType } from '../types';

type PropsType = {
  items: ReassignDocumentsMap | ReassignDocumentTemplatesMap | ReassignChangeRequestsMap | ReassignControlsMap;
  type: ReassignOwnerSummaryItemType;
};

/**
 * This exists because the "Documents" and "Change Requests" section of the summary screen when removing
 * a user (the "owner" association) is slightly different then the rest in how it displays the reassign string
 */
const ReassignOwnerSummaryItem = ({ items, type }: PropsType): ReactElement => {
  const { t } = useTranslation();
  const uniqueOwners = filterUniqueOwners(items);

  const getTitle = (summaryType: ReassignOwnerSummaryItemType) => {
    switch (summaryType) {
      case ReassignOwnerSummaryItemType.document:
        return t('reassignEntities.summary.documents');
      case ReassignOwnerSummaryItemType.documentTemplate:
        return t('reassignEntities.summary.documentTemplates');
      case ReassignOwnerSummaryItemType.changeRequest:
        return t('reassignEntities.summary.changeRequests');
      case ReassignOwnerSummaryItemType.control:
        return t('reassignEntities.summary.controls');
      default:
        return '';
    }
  };

  return (
    <QHeading size="sm" fontSize="md" fontWeight="bold">
      {getTitle(type)}
      {uniqueOwners.map(([owner, count]) => {
        const translationKey =
          count === 1
            ? 'reassignEntities.summary.ownershipTransfer'
            : 'reassignEntities.summary.ownershipTransferPlural';
        const translatedText = t(translationKey, { count, type, name: owner });

        return (
          <QText key={owner} fontSize="xs" fontWeight="light">
            {translatedText}
          </QText>
        );
      })}
    </QHeading>
  );
};

export default ReassignOwnerSummaryItem;
